import React, { Component } from 'react'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import PaymentSettingsViewUI from './PaymentSettingsViewUI.js'

class PaymentSettingsViewSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: [],
      successMsg: null,
      createOrUpdateMode: false,
      cancelMode: false,
      cancelSubmitted: false,
    }
  }

  render() {
    return (
      <PaymentSettingsViewUI
        context={this.props.context}
        paymentMethodList={this.props.paymentMethodList}
        stripeApiKey={this.props.stripeApiKey}
        messageList={this.props.messageList}
        onPaymentSettingsChange={this.props.onPaymentSettingsChange}
        //
        createOrUpdateMode={this.state.createOrUpdateMode}
        onCreateOrUpdateClick={this.onCreateOrUpdateClick}
        onCancelCreateOrUpdateClick={this.onCancelCreateOrUpdateClick}
        //
        cancelMode={this.state.cancelMode}
        onCancelClick={this.onCancelClick}
        onCancelCancelClick={this.onCancelCancelClick}
        onCancelSubmit={this.onCancelSubmit}
        cancelSubmitted={this.state.cancelSubmitted}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
      />
    )
  }

  onCreateOrUpdateClick = (event) => {
    this.setState({
      createOrUpdateMode: true,
      errorList: [],
      successMsg: null
    })
  }

  onCancelCreateOrUpdateClick = (event) => {
    this.setState({createOrUpdateMode: false})
  }

  onCancelClick = (event) => {
    this.setState({
      cancelMode: true,
      errorList: [],
      successMsg: null
    })
  }

  onCancelCancelClick = (event) => {
    this.setState({cancelMode: false, cancelSubmitted: false})
  }

  onCancelSubmit = (event) => {
    if (this.state.cancelSubmitted)
      return

    this.setState({
      errorList: [],
      successMsg: null,
      cancelSubmitted: true,
    })
    RestApiUtils.delete(this.props.context,
      `/api/accounts/${this.props.context.session.accountId}/paymentMethods/first`,
      this.onCancelSubmitCallback,
    )
  }

  onCancelSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      errorList: errorList,
      successMsg: response.success,
      cancelMode: false,
      createOrUpdateMode: false,
      cancelSubmitted: false,
    })

    if (errorList.length > 0)
      return

    setTimeout(() => {
      this.props.onPaymentSettingsChange()
    }, 2000);
  }
}

export default PaymentSettingsViewSF
